import { State } from '@progress/kendo-data-query';
import { Grid } from '@progress/kendo-react-grid';
import { FC, createRef } from 'react';
import useLineItemSummariesColumns from 'src/assets/static/view_invoice/lineItemSummariesColumns';
import GridWrapper from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';
import { InvoiceLineItem } from 'src/services/useInvoiceLineItemsApi';

const defaultProps = {
  showColumnMenu: false,
  sortable: false,
  DataItemKey: 'poId',
};

const initialLineItemSummariesState: State = {
  take: 20,
  skip: 0,
};

interface ClosePoWizardProps {
  lineItems: InvoiceLineItem[];
}

const ClosePoWizard: FC<ClosePoWizardProps> = ({ lineItems }) => {
  const { height } = useWindowSize();
  const tableRef = createRef<Grid>();
  const columns = useLineItemSummariesColumns(tableRef);

  const lineItemSummaries = lineItems.filter(
    (lineItem) => lineItem.poQty !== lineItem.previousQty + lineItem.quantityReceived
  );

  return lineItemSummaries.length ? (
    <>
      <div className="mt-1 mb-1 px-1">
        <p className="text-lg font-semibold mb-8">
          The following items will produce an item quantity variance. Please confirm you still want
          to close the PO.
          <br />
          No change to the PO will be allowed after it is closed.
        </p>
        <GridWrapper
          id="lineItemSummariesGrid"
          className="lineItemSummariesGrid viewInvoiceModalGrid"
          height={height > 420 ? '55vh' : '450px'}
          dataSource={lineItemSummaries}
          dataState={initialLineItemSummariesState}
          total={lineItemSummaries?.length}
          onDataStateChange={() => {}}
          columns={columns}
          {...defaultProps}
        />
      </div>
    </>
  ) : (
    <p> Are you sure you want to close the PO? </p>
  );
};

export default ClosePoWizard;
